/* LH | Partner set upsell, cart rules (first: metal key chains, ClickUp 123y1w8mc8r, Leon 17.10.2026;
 * all categories: Leon 20.10.2026)
 *
 * Loaded from snippets/cart-drawer.liquid (every page) and sections/main-cart-items.liquid.
 * After every cart change (and once on page load) we read /cart.js and enforce:
 * - An upsell line (variant in window.lhPartnerUpsellVariants, filled from every lh_partner_upsell
 *   entry, or any line with _partner_of) needs _partner_of pointing to a _customization_id of another
 *   line in the cart. Main item removed -> upsell removed.
 * - Quantity of an upsell line is always 1, whatever the quantity of the main item.
 * - Only one upsell line per main item.
 * Fixes go out in one /cart/update.js call (by line key). Then the drawer is re-rendered,
 * on the cart page the page reloads. Our own requests carry X-LH-Cart and never trigger us.
 *
 * Thumbnail (Leon 17.10.2026): Teeinblue replaces the cart image of a line with
 * _customization_id by its design preview. It finds that image by URL and takes the FIRST
 * match, so the upsell row renders the upsell product's own photo in Liquid (never the main
 * line's photo) and we copy the swapped preview from the main row (data-lh-cid) into the
 * partner row (data-lh-partner-of) here, whenever the cart DOM changes.
 */
(function () {
  if (window.__lhPartnerCartLoaded) return;
  window.__lhPartnerCartLoaded = true;

  var busy = false, again = false;

  function upsellIds() {
    var ids = {};
    (window.lhPartnerUpsellVariants || []).concat([window.lhPartnerUpsellVariant]).forEach(function (v) {
      if (Number(v)) ids[Number(v)] = true;
    });
    return ids;
  }
  function isUpsellLine(i, ids) {
    return !!ids[Number(i.variant_id)] || !!(i.properties && i.properties._partner_of);
  }

  async function refresh() {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && typeof drawer.renderContents === 'function') {
        var res = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'X-LH-Cart': '1' } });
        drawer.renderContents({ sections: await res.json() });
        if (cartIsEmpty(drawer)) drawer.classList.add('is-empty');
      }
    } catch (e) { console.warn('[LH Partner cart] drawer refresh failed', e); }
  }

  function cartIsEmpty(drawer) { return !drawer.querySelector('.cart-item'); }

  // Another tab of the shop may be adding the placeholder of a set right now (QA 26.10.2026: several tabs on one cart
  // turned fresh set lines into the single, its own window.__lhSetAddonPending is only known in that tab).
  // lh-set-switch.js keeps the end of its pending window in localStorage.
  function setAddonPending() {
    if (window.__lhSetAddonPending) return true;
    try { return Number(localStorage.getItem('lhSetAddonPendingUntil') || 0) > Date.now(); } catch (e) { return false; }
  }

  // A copy of a TeeInBlue customization on another variant of the same product, the same calls TeeInBlue's own SDK
  // makes on add to cart: read the customization, create it again with that variant (TeeInBlue then renders the print
  // files of that variant's base product, the single lantern has one print area), link it to the cart.
  // Returns the new id, or null when anything does not fit (tested 27.10.2026: names and preview stay the same).
  var TIB_CUSTOMIZATION = 'https://api.teeinblue.com/api/merchant/shopify/customization';
  async function cloneCustomization(cid, variantId, productId, cartToken) {
    try {
      var shop = (window.Shopify && window.Shopify.shop) || 'heyxdear.myshopify.com';
      var src = await (await fetch(TIB_CUSTOMIZATION + '/' + encodeURIComponent(cid) + '?shop=' + shop)).json();
      if (!src || !src.data || !productId) return null;
      var data = Object.assign({}, src.data, { platform_linked_id: String(variantId) });
      var res = await fetch(TIB_CUSTOMIZATION + '?shop=' + shop + '&id=' + productId, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: data, platform_variant_id: String(variantId) })
      });
      if (!res.ok) return null;
      var made = await res.json();
      if (!made || !made.id || String(made.platform_variant_id) !== String(variantId)) return null;
      var token = String(cartToken || '').split('?')[0];
      if (token) {
        fetch(TIB_CUSTOMIZATION + '/' + made.id + '/cart-token?shop=' + shop, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cart_token: token })
        }).catch(function () {});
      }
      return String(made.id);
    } catch (e) {
      return null;
    }
  }

  async function enforce(opts) {
    var ids = upsellIds();
    var waitForOtherTabs = !(opts && opts.now);
    if (busy) { again = true; return; }
    again = false;
    busy = true;
    try {
      var cart = await (await fetch('/cart.js', { headers: { 'X-LH-Cart': '1' } })).json();
      var mains = {};
      cart.items.forEach(function (i) {
        var cid = i.properties && i.properties._customization_id;
        if (!isUpsellLine(i, ids) && cid) mains[String(cid)] = true;
      });
      var seen = {}, updates = {}, changes = 0, addedSingle = false;

      // LH | Poster frame (Leon 21.10.2026, snippets/lh-frame-upsell.liquid): a frame line (SKU PSF..., linked by
      // _tib_customization_id, from the theme block or the old TeeInBlue layer) follows the quantity of its poster
      // and goes when the poster goes, only one frame per poster. A poster whose
      // _tib_addon_variant points to a frame that is no longer in the cart loses that property, otherwise
      // fulfillment would send it neither to posterXXL nor to MerchOne. Not while lh-frame-upsell.js is still
      // adding that poster's frame (window.__lhFramePending), the poster is flagged first on purpose.
      var posterQty = {}, frameOf = {}, pending = window.__lhFramePending || {};
      cart.items.forEach(function (i) {
        var cid = i.properties && i.properties._customization_id;
        if (cid && /^poster-digital-/i.test(i.sku || '')) posterQty[String(cid)] = i.quantity;
      });
      cart.items.forEach(function (i) {
        var f = /^PSF/i.test(i.sku || '') && i.properties && i.properties._tib_customization_id;
        if (!f) return;
        f = String(f);
        var want = posterQty[f] && !frameOf[f] ? posterQty[f] : 0;
        if (want) frameOf[f] = Number(i.variant_id);
        if (i.quantity !== want) { updates[i.key] = want; changes++; }
      });
      var stale = cart.items.filter(function (i) {
        var p = i.properties || {}, a = p._tib_addon_variant;
        if (!a || !p._customization_id || !/^poster-digital-/i.test(i.sku || '')) return false;
        var vid = Number(String(a).split(':')[0]), cid = String(p._customization_id);
        if (pending[cid]) return false;
        return !cart.items.some(function (o) {
          return Number(o.variant_id) === vid && updates[o.key] !== 0 && o.properties &&
            String(o.properties._tib_customization_id || '') === cid;
        });
      });
      for (var s = 0; s < stale.length; s++) {
        var props = Object.assign({}, stale[s].properties);
        delete props._tib_addon_variant;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-LH-Cart': '1' },
          body: JSON.stringify({ id: stale[s].key, quantity: stale[s].quantity, properties: props })
        });
        changes++;   // only the poster's line key changes here, the keys in updates stay valid
      }

      // LH | 2-pack set with a placeholder addon line (snippets/lh-set-addon-map.liquid, Leon 23.10.2026, test in DE):
      // the set variant costs as much as the single, the second piece is paid through the addon line. A set line
      // whose addon line is gone (customer removed it) is turned back into the single with the same quantity,
      // otherwise two pieces would go out for the price of one. Not while lh-set-switch.js is still adding
      // the addon (window.__lhSetAddonPending).
      // The single gets its OWN TeeInBlue customization, a copy of the set's design on the single variant
      // (cloneCustomization below, Leon 27.10.2026). Until then it kept the set's _customization_id, TeeInBlue rendered
      // the set's two print files (GOLD + GOLD 2) for it and Printlabs rejected the whole order (84 orders 23 to 27 Oct).
      // If the copy fails the set line stays as it is (two pieces for the single price, but an order Printlabs takes)
      // and the next cart check tries again. Never a single with the set's customization.
      var addonMap = window.lhSetAddonMap || [];
      // A pair from the set picker carries the product handle: set SKUs like candle-subli-2set are shared by many
      // products that sell the set at its full price, only lines of that product belong to the pair.
      function pairFits(x, line) { return x.set === line.sku && (!x.handle || x.handle === line.handle); }
      if (addonMap.length && !window.__lhSetAddonPending && !(waitForOtherTabs && setAddonPending())) {
        var withAddon = {};
        cart.items.forEach(function (i) {
          var po = i.properties && i.properties._partner_of;
          if (po && updates[i.key] !== 0) withAddon[String(po)] = true;
        });
        for (var a = 0; a < cart.items.length; a++) {
          var line = cart.items[a];
          var pair = addonMap.find(function (x) { return pairFits(x, line); });
          var lcid = line.properties && line.properties._customization_id;
          if (!pair || !lcid || withAddon[String(lcid)]) continue;
          var pj = await (await fetch('/products/' + line.handle + '.js', { headers: { 'X-LH-Cart': '1' } })).json();
          var single = (pj.variants || []).find(function (v) { return v.sku === pair.main; });
          if (!single) continue;
          var newCid = await cloneCustomization(String(lcid), single.id, line.product_id, cart.token);
          if (!newCid) { console.warn('[LH Partner cart] set line kept, design copy for the single failed', lcid); continue; }
          var props = Object.assign({}, line.properties || {}, { _customization_id: newCid });
          var added = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-LH-Cart': '1' },
            body: JSON.stringify({ items: [{ id: single.id, quantity: line.quantity, properties: props }] })
          });
          if (!added.ok) continue;
          addedSingle = true;
          updates[line.key] = 0;
          changes++;
          // TeeInBlue addon lines of this item (e.g. the LED tealight, _tib_customization_id) follow the new design.
          for (var t = 0; t < cart.items.length; t++) {
            var tl = cart.items[t];
            if (!tl.properties || String(tl.properties._tib_customization_id) !== String(lcid) || Object.prototype.hasOwnProperty.call(updates, tl.key)) continue;
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'X-LH-Cart': '1' },
              body: JSON.stringify({ id: tl.key, quantity: tl.quantity, properties: Object.assign({}, tl.properties, { _tib_customization_id: newCid }) })
            });
          }
        }
      }

      // Placeholder lines of the 2-pack set (lhSetAddonMap, Leon 23.10.2026): quantity follows the set line,
      // two sets = two placeholders, else the second pieces would be sold for the price of one.
      var addonIds = {}, setQty = {};
      addonMap.forEach(function (x) { addonIds[Number(x.addon)] = true; });
      cart.items.forEach(function (i) {
        var cid = i.properties && i.properties._customization_id;
        if (cid && addonMap.some(function (x) { return pairFits(x, i); })) setQty[String(cid)] = i.quantity;
      });
      cart.items.forEach(function (i) {
        if (/^PSF/i.test(i.sku || '') && i.properties && i.properties._tib_customization_id) return;
        if (!isUpsellLine(i, ids)) return;
        var p = i.properties && i.properties._partner_of ? String(i.properties._partner_of) : '';
        var want = p && mains[p] && !seen[p] ? (addonIds[Number(i.variant_id)] ? (setQty[p] || 0) : 1) : 0;
        if (want) seen[p] = true;
        if (i.quantity !== want) { updates[i.key] = want; changes++; }
      });
      // Extras whose main item is gone (Agent QA 28.10.2026: bag 2,95 € and LED tealight 6,95 € stayed alone in the cart
      // after the customer removed the bear family or the tealight): theme bags and stands (_bag_of) and TeeInBlue
      // addon lines (_tib_customization_id, e.g. LED, gift box; frames are handled above) go with their item.
      // Not in a run that just swapped a set for the single, those addon lines were pointed at the new design.
      if (!addedSingle) {
        var cids = {};
        cart.items.forEach(function (i) {
          var cid = i.properties && i.properties._customization_id;
          if (cid && updates[i.key] !== 0) cids[String(cid)] = true;
        });
        cart.items.forEach(function (i) {
          var p = i.properties || {};
          if (Object.prototype.hasOwnProperty.call(updates, i.key) || /^PSF/i.test(i.sku || '')) return;
          var of = p._bag_of || (!p._customization_id && p._tib_customization_id);
          if (of && !cids[String(of)]) { updates[i.key] = 0; changes++; }
        });
      }

      // Only Prio+ left (QA 26.10.2026, BE-NL, CH, AT, BE-FR, FR): ck-prio-shipping.js removes it a moment after our
      // update without redrawing the drawer, which then showed Prio+ and the checkout button on an empty cart.
      // Remove it in the same call, the drawer below is then drawn from the empty cart.
      if (changes) {
        var real = cart.items.some(function (i) {
          var q = Object.prototype.hasOwnProperty.call(updates, i.key) ? updates[i.key] : i.quantity;
          return q > 0 && !(i.properties && i.properties._isPrio);
        });
        if (!real && !addedSingle) {
          cart.items.forEach(function (i) { if (i.properties && i.properties._isPrio) updates[i.key] = 0; });
        }
      }
      if (changes) {
        var res = await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-LH-Cart': '1' },
          body: JSON.stringify({ updates: updates })
        });
        if (res.ok) await refresh();
      }
    } catch (e) {
      console.warn('[LH Partner cart] check failed', e);
    } finally {
      busy = false;
      if (again) { again = false; setTimeout(enforce, 150); }
    }
  }

  /* ---------- design preview on the partner row ---------- */
  function previewImg(row) {
    var img = row.querySelector('.tee-cart-thumbnail img') || row.querySelector('.cart-item__image, .cart-item__media img');
    if (!img) return null;
    var src = img.currentSrc || img.getAttribute('src') || '';
    return /teeinblue/.test(src) ? img : null;
  }
  // Teeinblue's rendered preview of a customization lives at a fixed URL (the same one its
  // cart thumbnail uses). Teeinblue's own swap of the main row is late or absent after an
  // AJAX add, so the partner row loads that URL directly and falls back to the swapped
  // image only when the direct one is not ready yet.
  function previewUrl(cid) { return 'https://cdn.teeinblue.com/customizations/' + encodeURIComponent(cid) + '.jpg'; }
  function setThumb(target, url) {
    if (target.getAttribute('src') === url || target.dataset.lhTried === url) return;
    target.dataset.lhTried = url;
    var probe = new Image();
    probe.onload = function () {
      target.setAttribute('src', url);
      target.removeAttribute('srcset');
      target.style.objectFit = 'contain';
    };
    probe.onerror = function () { delete target.dataset.lhTried; };
    probe.src = url;
  }
  // A partner row sits directly below its main row (Leon 24.10.2026): the cart lists the newest line first, so the
  // second lantern or partner key chain would otherwise appear above the item it belongs to.
  // A partner row whose main row is gone is hidden at once (QA 26.10.2026, FR: the second lantern stood alone in the
  // drawer for seconds after the main line was removed). The cart rules above remove the line itself.
  function placeRows() {
    document.querySelectorAll('[data-lh-partner-of]').forEach(function (row) {
      var cid = row.getAttribute('data-lh-partner-of');
      var main = cid && row.parentNode && row.parentNode.querySelector('[data-lh-cid="' + cid.replace(/"/g, '\\"') + '"]');
      if (main && main.nextElementSibling !== row) main.parentNode.insertBefore(row, main.nextElementSibling);
      var orphan = !main;
      if (orphan !== (row.dataset.lhOrphan === '1')) {
        if (orphan) { row.dataset.lhOrphan = '1'; row.style.display = 'none'; }
        else { delete row.dataset.lhOrphan; row.style.display = ''; }
      }
    });
  }
  function mirrorThumbs() {
    placeRows();
    document.querySelectorAll('[data-lh-partner-of]').forEach(function (row) {
      var cid = row.getAttribute('data-lh-partner-of');
      var target = row.querySelector('.cart-item__image, .cart-item__media img');
      if (!cid || !target) return;
      if (/cdn\.teeinblue\.com/.test(target.getAttribute('src') || '')) return;
      var main = document.querySelector('[data-lh-cid="' + cid.replace(/"/g, '\\"') + '"]');
      var swapped = main && previewImg(main);
      setThumb(target, swapped ? (swapped.currentSrc || swapped.getAttribute('src')) : previewUrl(cid));
    });
  }
  var mirrorTimer = null;
  // Throttle, not debounce: the drawer's reservation countdown mutates the DOM several
  // times per second, a debounce would never fire while it runs (seen live 17.10.2026).
  function queueMirror() {
    if (mirrorTimer) return;
    mirrorTimer = setTimeout(function () { mirrorTimer = null; mirrorThumbs(); }, 150);
  }
  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      if (records.some(function (m) { return m.target.closest && m.target.closest('cart-drawer, #CartDrawer, cart-items, #main-cart-items'); })) queueMirror();
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
  }
  document.addEventListener('teeinblue-event-cart-refreshed', queueMirror);
  queueMirror();
  // Teeinblue loads its preview image a moment after the swap: a few late passes
  [500, 1500, 3000, 6000, 12000].forEach(function (ms) { setTimeout(mirrorThumbs, ms); });

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = (init && init.headers) || {};
    var own = (typeof h.get === 'function' ? h.get('X-LH-Cart') : h['X-LH-Cart']) === '1';
    var p = origFetch.apply(this, arguments);
    if (!own && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) setTimeout(enforce, 300); }).catch(function () {});
    }
    return p;
  };

  // One full run on the current cart: waits for a run in progress, then runs again, so callers get a clean cart.
  async function enforceSettled(opts) {
    for (var n = 0; n < 50 && busy; n++) await new Promise(function (r) { setTimeout(r, 100); });
    await enforce(opts);
  }
  window.lhPartnerEnforce = enforceSettled;

  /* ---------- checkout gate (Leon 25.10.2026) ----------
   * Two orders reached the checkout with set lines and no placeholder (2 lanterns for the price of 1, #HD-98377213,
   * #HD-98377233). Teeinblue opens the drawer the moment the set line is in the cart, the placeholder follows about a
   * second later (longer on a slow phone), and the drawer's checkout button (ck-prio-shipping.js) adds Prio+ and goes
   * to /checkout at once, before any cart rule could run. So every checkout button of the theme now waits first:
   * 1. until lh-set-switch.js has added the placeholder (window.lhSetAddonSettled, at most 6 s),
   * 2. until the cart rules above have run once (a set line still without placeholder becomes the single).
   * Then the original click is replayed, so the existing handlers (Prio+, countdown) run as before. Fails open after
   * 8 s or on any error: a slow cart must never block a purchase. Express buttons (Shop Pay, PayPal) live in iframes
   * and cannot be held here; the checkout rule in checkout-blocks-custom covers those. */
  var GATE = '#CartDrawer-Checkout, #checkout, button[name="checkout"], input[name="checkout"]';
  var gating = false;
  function waitMax(p, ms) {
    return Promise.race([p, new Promise(function (r) { setTimeout(r, ms); })]);
  }
  async function readyForCheckout() {
    if (typeof window.lhSetAddonSettled === 'function') await waitMax(window.lhSetAddonSettled(), 6000);
    if (window.__lhSetAddonPending) { // stuck: stop waiting, let the rules decide
      if (typeof window.lhSetAddonCancel === 'function') window.lhSetAddonCancel();
      window.__lhSetAddonPending = false;
    }
    await enforceSettled({ now: true });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(GATE);
    if (!btn) return;
    if (btn.dataset.lhGatePass === '1') { delete btn.dataset.lhGatePass; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (gating) return;
    gating = true;
    btn.classList.add('loading');
    waitMax(readyForCheckout().catch(function (err) { console.warn('[LH Partner cart] checkout gate', err); }), 8000).then(function () {
      gating = false;
      btn.classList.remove('loading');

      // the drawer may have been re-rendered meanwhile (new placeholder line): click the button that is there now
      var live = btn.isConnected ? btn : (btn.id && document.getElementById(btn.id)) || null;
      if (!live) return;
      live.dataset.lhGatePass = '1';
      live.click();
    });
  }, true);
  // Back from the checkout the browser restores the page as it was (bfcache): the drawer still shows the cart before
  // Prio+ was added, with stale line numbers for its buttons. Redraw it quietly (without opening it) and run the rules.
  window.addEventListener('pageshow', async function (e) {
    if (!e.persisted) return;
    var drawer = document.querySelector('cart-drawer');
    try {
      if (drawer && !/\/cart\/?$/.test(window.location.pathname)) {
        var res = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble', { headers: { 'X-LH-Cart': '1' } });
        var sections = await res.json();
        var parse = function (html, sel) { var d = new DOMParser().parseFromString(html, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
        var inner = parse(sections['cart-drawer'], '#CartDrawer');
        var target = document.getElementById('CartDrawer');
        if (inner !== null && target) target.innerHTML = inner;
        var bubble = document.getElementById('cart-icon-bubble');
        var b = parse(sections['cart-icon-bubble'], '.shopify-section');
        if (bubble && b !== null) bubble.innerHTML = b;
        drawer.classList.toggle('is-empty', cartIsEmpty(drawer));
      }
    } catch (err) { console.warn('[LH Partner cart] bfcache redraw failed', err); }
    enforce();
  });
  // Express buttons on /cart (Shop Pay, PayPal, ...) live in iframes and skip the gate above. Until the checkout rule
  // of hey-dear/checkout-blocks-custom#20 is live they stay disabled until the rules have run once on this page
  // (a set line without its placeholder is the single by then). Fails open after 8 s.
  var expressHold = /\/cart\/?$/.test(window.location.pathname);
  if (expressHold) {
    var holdCss = document.createElement('style');
    holdCss.textContent = '.cart__dynamic-checkout-buttons{pointer-events:none;opacity:.5}';
    document.head.appendChild(holdCss);
    var releaseExpress = function () { if (holdCss.parentNode) holdCss.parentNode.removeChild(holdCss); };
    setTimeout(releaseExpress, 8000);
  }
  async function firstRun() {
    try {
      await enforceSettled();
      // another tab is still adding a placeholder: wait for it, then check again before the express buttons open
      for (var n = 0; n < 16 && expressHold && setAddonPending(); n++) await new Promise(function (r) { setTimeout(r, 500); });
      if (expressHold && n) await enforceSettled();
    } catch (e) {}
    if (expressHold) releaseExpress();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', firstRun);
  else firstRun();
})();
